// extracted by mini-css-extract-plugin
export var closeButton = "_v-5";
export var container = "_v-0";
export var contentContainer = "_v-1";
export var desktop = "_v-2";
export var fullModalImage = "_v-6";
export var mobile = "_v-3";
export var withImage = "_v-4";